"use strict";

const css = require("js/css_constants");
const popupModule = require("js/controls/popup_control");
const utils = require("js/util");
const events = require("js/event_helper");
const keyModule = require("js/keyboard.js");

import { AbstractFilter } from "./abstract-filter.js";

const searchInputSelector = "#search-input";
const searchBodyInputSelector = "#search-fulltext-input";

export const FILTER_REQUEST_SEARCH = "filter-request-search";
export const FILTER_SAVE_NEW = "filter-save-new-filter";

const FIXED_FAKED_ATTRIBUTES = [
    "data-preselected-title",
    "data-preselected-body",
    "data-preselected-accounts",
    "data-preselected-categories",
];

/**
 * Search for "newtab-popup.html.component" for the html code
 */
class NewTabPopup extends HTMLElement {
    constructor() {
        super();
        this._originElement = null;
    }

    connectedCallback() {
        const template = document.querySelector("template#ldc-new-tab-popup");
        const content = template.content.cloneNode(true);

        this.appendChild(content);

        // add events for the cancel and save buttons
        this.querySelectorAll(".cancel").forEach((each) => {
            each.addEventListener("click", (event) => {
                popupModule.hide();
            });
        });

        const that = this;
        this.querySelector(".newtab-form").addEventListener("submit", (event) => {
            event.preventDefault();

            let inputName = that.querySelector("#name");
            let selectorUser = that.querySelector("#selectorUser");
            let selectorCategory = that.querySelector("#selectorCategory");

            let parentContainer = utils.findParentWithSelector(this.originElement, "[phx-target]");
            events.dispatch(FILTER_SAVE_NEW, parentContainer, {
                name: inputName.value,
                overall_filter: {
                    categories: selectorCategory.getArrayValue(),
                    user_ids: selectorUser.getArrayValue(),
                },
            });
            console.log("Done creating new tab");
            popupModule.hide();
        });
    }

    set originElement(value) {
        // let categorySelector = this.querySelector("ldc-category-selector");
        this._originElement = value;
    }

    get originElement() {
        return this._originElement;
    }
}

window.customElements.define("ldc-new-tab-popup", NewTabPopup);

function __createFilter(self) {
    const container = document.createElement("ldc-new-tab-popup");
    container.originElement = self;
    popupModule.show(container, container);
}

function __saveFilter(self, input) {
    events.dispatch(FILTER_SAVE_NEW, self.__root.host, {
        name: input.value,
        title: self.__titleInput.value,
        body: self.__bodyInput.value,
        categories: self.__categorySelector.getArrayValue(),
        accounts: self.__userSelector.getArrayValue(),
    });
}

class FilterDefault extends AbstractFilter {
    __abstractConnectedCallback() {
        const template = document.querySelector("template#ldc-filter-default");
        const content = template.content.cloneNode(true);
        this.__root.appendChild(content);

        let that = this;
        this.__root.querySelector("#search-btn").addEventListener("click", this.search.bind(this));

        // Clear button should reset and trigger a search
        this.__root.querySelector("#clear-btn").addEventListener("click", (e) => {
            that.resetToBlank();
            that.search();
        });

        const saveFilterBtn = this.__root.querySelector("#save-filter-btn");
        saveFilterBtn.addEventListener("click", (ev) => __createFilter(this));

        if (this.getAttribute("saveable") !== "true") {
            saveFilterBtn.disabled = "true";
        }

        if (window.ldc.permission.advancedCardSearch) {
            this.__optionsPopup = this.__root.querySelector("#options-popup");

            const advancedOptionsButtons = this.__root.querySelector("#advanced-options-btn");
            advancedOptionsButtons.classList.remove(css.disabled);

            advancedOptionsButtons.addEventListener(
                "click",
                ((e) => {
                    e.stopPropagation();
                    this.__optionsPopup.classList.remove(css.disabled);
                }).bind(this),
            );

            // disable include deleted snapshots feature
            if (!window.ldc.permission.viewDeletedSnapshots) {
                let includeDeleteSnapshots = advancedOptionsButtons.querySelector("#include-deleted-snapshots");
                if (includeDeleteSnapshots) {
                    includeDeleteSnapshots.classList.add(css.disabled);
                } else {
                    content.warn("Failed to find the include delete snapshot button");
                }
            }

            document.addEventListener("click", (e) => {
                if (!this.__optionsPopup.classList.contains(css.disabled)) {
                    this.__optionsPopup.classList.add(css.disabled);
                }
            });
        }

        this.__titleInput = this.__root.querySelector(searchInputSelector);
        this.__titleInputFixed = this.__root.querySelector("#search-input-fixed");

        this.__bodyInput = this.__root.querySelector(searchBodyInputSelector);
        this.__bodyInputFixed = this.__root.querySelector("#search-fulltext-fixed");

        this.__categorySelector = this.__root.querySelector("ldc-category-selector");
        this.__categoryFixed = this.__root.querySelector("#category-fixed");

        this.__userSelector = this.__root.querySelector("ldc-user-selector");
        this.__userFixed = this.__root.querySelector("#user-fixed");

        this.__deletedByOwner = this.__root.querySelector("input#deleted-by-owner");
        this.__includeSnapshots = this.__root.querySelector("input#include-snapshots");
        this.__enablePagination = this.__root.querySelector("input#enable-pagination");

        this.__loadDefault();

        const observer = new MutationObserver(this.__onDatasetMutate.bind(this));
        observer.observe(this, { attributes: true });
    }

    __onDatasetMutate(mutationList, observer) {
        for (const mutation of mutationList) {
            if (mutation.type === "attributes" && FIXED_FAKED_ATTRIBUTES.includes(mutation.attributeName)) {
                this.__loadDefault();
            }
        }
    }

    __addPreselectedBox(parent, content) {
        parent.classList.add("fixed-faked-item-container");
        parent.classList.add("align-end");

        content
            .split(" ")
            .filter((split) => split != "")
            .forEach((split) => {
                const text = document.createTextNode(split);

                const span = document.createElement("SPAN");
                span.classList.add("fixed-faked-item");
                span.appendChild(text);

                parent.appendChild(span);
            });
    }

    __loadDefault() {
        this.__loadInputDefaults();

        // This is a very strange behaviour with JS, in some cases the `this.__categorySelector` is defined
        // but not the .setValue function (I have no idea why and if this is a WebComponent issue)
        if (this.__categorySelector.setValue !== undefined) {
            this.__categorySelector.setValue([]);
        }
        if (this.__userSelector.setValue !== undefined) {
            this.__userSelector.setValue([]);
        }

        console.log("Kiru Add preselected items for category and user");
        this.__addPreselectedItems(this.__categoryFixed, "data-preselected-categories", true);
        this.__addPreselectedItems(this.__userFixed, "data-preselected-accounts", false);

        if (window.ldc.permission.advancedCardSearch) {
            this.__deletedByOwner.checked = false;
            this.__includeSnapshots.checked = false;

            this.__enablePagination.checked = true;
        } else {
            this.__enablePagination.checked = true;
        }
    }

    __loadInputDefaults() {
        utils.removeAllChildren(this.__titleInputFixed);
        if (this.dataset.preselectedTitle != null) {
            this.__addPreselectedBox(this.__titleInputFixed, this.dataset.preselectedTitle);
        }
        this.__titleInput.value = this.dataset["title"] || "";

        utils.removeAllChildren(this.__bodyInputFixed);
        if (this.dataset.preselectedBody != null) {
            this.__addPreselectedBox(this.__bodyInputFixed, this.dataset.preselectedBody);
        }
        this.__bodyInput.value = this.dataset["body"] || "";
    }

    __addPreselectedItems(container, name, actsAsLink) {
        utils.removeAllChildren(container);

        const items = this.getAttribute(name).split("=#!=");

        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            if (item != null && item != "") {
                const splitAt = item.indexOf("#");
                const id = item.slice(0, splitAt);
                const title = item.slice(splitAt + 1);

                const div = document.createElement("div");
                div.classList.add("fixed-faked-item");
                div.appendChild(document.createTextNode(title));

                if (actsAsLink) {
                    div.classList.add("clickable");

                    div.addEventListener("click", (e) => {
                        events.displayCard(this, id, { composed: true });
                    });
                }

                container.appendChild(div);
            }
        }
    }

    search(event = null, { titleSearch = null, cardTypes = [], outputFormat = null } = {}) {
        if (event != null) {
            // otherwise we get strange reload effects...
            event.preventDefault();
            event.stopPropagation();
        }

        // a programmatic search for a specific title will override user input, this is intentional
        if (titleSearch != null) {
            this.__root.querySelector(searchInputSelector).value = titleSearch;
        }

        events.dispatch(FILTER_REQUEST_SEARCH, this.__root.host, this.getSearchRequest(cardTypes, outputFormat));
    }

    getSearchRequest(cardTypes = [], outputFormat = null) {
        const request = this.createMemento();
        request.cardTypes = cardTypes;
        request.outputFormat = outputFormat;
        return request;
    }

    // B aware, this is not "reset to blank", it's rather "reset to default"
    reset() {
        console.log("Reset clicked");
        this.__loadInputDefaults();
    }

    resetToBlank() {
        this.__titleInput.value = "";
        this.__bodyInput.value = "";

        this.__categorySelector.clear();
        this.__addPreselectedItems(this.__categoryFixed, "data-preselected-categories", true);
        this.__userSelector.clear();
        this.__addPreselectedItems(this.__userFixed, "data-preselected-accounts", false);
    }

    __focusSelector() {
        return searchInputSelector;
    }

    focus() {
        this.__root.querySelector("input#search-input").focus();
    }

    updateCurrentHorizon(horizonId) {
        this.__root
            .querySelectorAll("ldc-category-selector", "ldc-user-selector")
            .forEach((selector) => selector.updateCurrentHorizon(horizonId));
    }

    createMemento() {
        return {
            title: this.__root.querySelector(searchInputSelector).value,
            fulltext: this.__root.querySelector(searchBodyInputSelector).value,
            categories: this.__categorySelector.getValue(),
            accounts: this.__userSelector.getValue(),
            deletedByOwner: this.__deletedByOwner.checked,
            includeSnapshots: this.__includeSnapshots.checked,
            enablePagination: this.__enablePagination.checked,
        };
    }

    loadMemento(memento) {
        this.__root.querySelector(searchInputSelector).value = memento.title;
        this.__root.querySelector(searchBodyInputSelector).value = memento.fulltext;
        this.__categorySelector.setValue(memento.categories);
        this.__userSelector.setValue(memento.accounts);
        this.__deletedByOwner.checked = memento.deletedByOwner;
        this.__includeSnapshots.checked = memento.includeSnapshots;
        this.__enablePagination.checked = memento.enablePagination;
    }
}

customElements.define("ldc-filter-default", FilterDefault);
